import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { cloneQueryGroup, generateQuery, validateQuery } from '../utils/query-helper';
var AdvancedComponent = (function () {
    function AdvancedComponent(cdRef) {
        this.cdRef = cdRef;
        this.fields = [];
    }
    Object.defineProperty(AdvancedComponent.prototype, "queryTemplate", {
        get: function () {
            return this._queryTemplate;
        },
        set: function (val) {
            this._queryTemplate = val;
            this.tempQueryTemplate = cloneQueryGroup(this._queryTemplate);
            this._rules = this.getRules(this.tempQueryTemplate);
        },
        enumerable: true,
        configurable: true
    });
    AdvancedComponent.prototype.ngAfterViewInit = function () {
        this.cdRef.detectChanges();
    };
    AdvancedComponent.prototype.reset = function () {
        this.queryTemplate = this._queryTemplate;
    };
    AdvancedComponent.prototype.getQuery = function () {
        return generateQuery(this.tempQueryTemplate, false);
    };
    AdvancedComponent.prototype.getOriginalQuery = function () {
        return generateQuery(this.tempQueryTemplate, true);
    };
    AdvancedComponent.prototype.validateQuery = function () {
        return validateQuery(this.tempQueryTemplate);
    };
    AdvancedComponent.prototype.getRules = function (group) {
        var rules = [];
        if (group.rules && group.rules != null && group.rules.length > 0) {
            rules = rules.concat(group.rules);
        }
        if (group.groups && group.groups != null && group.groups.length > 0) {
            for (var _i = 0, _a = group.groups; _i < _a.length; _i++) {
                var child = _a[_i];
                rules = rules.concat(this.getRules(child));
            }
        }
        return rules;
    };
    return AdvancedComponent;
}());
export { AdvancedComponent };
AdvancedComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-query-advanced',
                template: "\n  <div class=\"row\">\n    <div class=\"form-inline\">\n      <ngx-query-group [group]=\"tempQueryTemplate\" [fields]=\"fields\"></ngx-query-group>\n    </div>\n  </div>\n  "
            },] },
];
/** @nocollapse */
AdvancedComponent.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
]; };
AdvancedComponent.propDecorators = {
    'fields': [{ type: Input },],
    'queryTemplate': [{ type: Input },],
};
//# sourceMappingURL=advanced.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/advanced/advanced.component.js
// module id = null
// module chunks = 